import React, {useState} from 'react'
import styled from 'styled-components'
import Markdown from 'react-markdown'
import {ThreadMessage} from 'lib/obie/use-assistant-thread'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import Tooltip from '@material-ui/core/Tooltip'
import {convertMarkdownToText} from 'lib/convert-markdown-to-text'

interface ThreadMessagesProps {
  messages: ThreadMessage[]
}

export default function ThreadMessages(props: ThreadMessagesProps) {
  const {messages} = props

  return (
    <Box>
      {messages.map((message, index) => (
        <MessageContainer key={index} isUser={message.type === 'user'}>
          <MessageContent isUser={message.type === 'user'}>
            {removeSourceReferences(message.content)}
          </MessageContent>
          {message.type === 'assistant' && (
            <CopyButton content={message.content} />
          )}
        </MessageContainer>
      ))}
    </Box>
  )
}

function CopyButton({content}: {content: string}) {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    const plainText = convertMarkdownToText(content)
    navigator.clipboard.writeText(plainText)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Tooltip title={copied ? 'Copied!' : 'Copy to clipboard'} placement="top">
      <CopyIconButton onClick={handleCopy} aria-label="copy to clipboard">
        <FileCopyIcon fontSize="small" />
      </CopyIconButton>
    </Tooltip>
  )
}

function removeSourceReferences(text: string) {
  return text.replace(/【\d+(?::\d+)?†source】/g, '')
}

const Box = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  overflow-y: auto;
`

const MessageContainer = styled.div<{isUser?: boolean}>`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 760px;
  margin: 20px;
  align-self: ${(props) => (props.isUser ? 'flex-end' : 'flex-start')};

  &:hover {
    button {
      opacity: 1;
    }
  }
`

const MessageContent = styled(Markdown)<{isUser?: boolean}>`
  padding: 20px;
  border-radius: 16px;
  background: ${(props) => (props.isUser ? '#1a2847' : '#050f27')};
  color: #fff;
  align-self: ${(props) => (props.isUser ? 'flex-end' : 'flex-start')};
  width: 100%;
`

const CopyIconButton = styled.button`
  position: absolute;
  bottom: 8px;
  right: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`
